import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle,{directives:[{name:"t",rawName:"v-t",value:('session.card.sessionsByCountry'),expression:"'session.card.sessionsByCountry'"}]}),_c(VCardText,[_c('map-chart',{staticStyle:{"z-index":"2"},attrs:{"country-data":_vm.getData,"highColor":"#ff0000","lowColor":"#aaaaaa","countryStrokeColor":"#909090","defaultCountryFillColor":"#dadada","showLegend":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }